import { useAtom, useSetAtom } from 'jotai';
import { fullScreenAtom } from '.';

const useFullScreen = () => {
    return useAtom(fullScreenAtom)
}

export const useSetFullScreen = () => useSetAtom(fullScreenAtom);


export default useFullScreen